import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'Blocks'
import { UrlBuilder } from 'Utils'

const FilterButton = ({ queryString }) => {
  const builder = new UrlBuilder(queryString)
  const filterTo = builder.setDialogView('Refine').getQueryString()
  return (
    <div className="product-list-actions">
      <Link to={filterTo}>
        <button className="filter-trigger">
          <span>FILTER</span>
        </button>
      </Link>
    </div>
  )
}

FilterButton.propTypes = {
  queryString: PropTypes.any
}

export default FilterButton
